import { ToastProgrammatic } from 'buefy';
import i18n from '@/localization/localization';

export const showErrorNotification = (translationKey) => {
    ToastProgrammatic.open({
        duration: 3000,
        message: i18n.t(translationKey).toString(),
        type: 'is-danger',
    });
};
